// import { ListGuesser } from 'react-admin'
import { ReferralCampaignList } from './ReferralCampaignList'
import CampaignIcon from '@material-ui/icons/LocalCafe'

export const referral_campaign = {
  list: ReferralCampaignList,
  icon: CampaignIcon,
}
